import React from 'react'
import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'
import styles from './TecnicaConsigliata.module.sass'
import type { TecnicaConsigliataType } from '@utils/types'
import BadgeEconomico from '@components/atoms/NewIcons/BadgeEconomico'

export interface TecnicaConsigliataProps {
  consiglio: TecnicaConsigliataType
  onSelect: (consiglio: TecnicaConsigliataType) => void
  disabled?: boolean
}

const TecnicaConsigliata = ({ consiglio, onSelect, disabled = false }: TecnicaConsigliataProps) => {
  const t = useTrans()
  const { tecnica, colori, totale, totaleAttuale, risparmioPercentuale } = consiglio
  const nomeColori = colori.full_color
    ? colori.nome
    : `${colori.numero_colori} ${colori.numero_colori === 1 ? t('colore') : t('colori')}`
  const nome = `${tecnica.nome} - ${nomeColori}`
  const percentuale = risparmioPercentuale < 1 ? '<1' : Math.floor(risparmioPercentuale)
  const prezzo = `${priceNotation(totale, 2)}€`
  const prezzoAttuale = `${priceNotation(totaleAttuale, 2)}€`

  return (
    <div className={`${styles.root}`}>
      <span className={styles.badge}>
        <BadgeEconomico />
      </span>
      <div className={styles.content}>
        <div className={styles.title}>
          {t('Con')}: <strong>{tecnica.nome}</strong>
        </div>
        <div className={styles.prezzi}>
          <del className={styles.prezzoAttuale} title={t('Prezzo attuale')}>
            {prezzoAttuale}
          </del>
          <strong className={styles.prezzo}>{prezzo}</strong>
          <span className={styles.sconto}>-{percentuale}%</span>
        </div>
      </div>
      <button
        type="button"
        className={styles.button}
        disabled={disabled}
        onClick={() => onSelect(consiglio)}
      >
        {t('Aggiorna la configurazione')}
      </button>
    </div>
  )
}

export default TecnicaConsigliata
